var PartnerProfileEnum = /* @__PURE__ */ ((PartnerProfileEnum2) => {
  PartnerProfileEnum2["PARTNER_PROFILE_SERVICES_BUTTON"] = "partner-profile--services-button";
  PartnerProfileEnum2["PARTNER_REDIRECT_MODAL_TITLE"] = "partner-redirect-modal--title";
  PartnerProfileEnum2["PARTNER_REDIRECT_MODAL_CLOSE_BUTTON"] = "partner-redirect-modal--close-button";
  PartnerProfileEnum2["PARTNER_REDIRECT_MODAL_TEXT"] = "partner-redirect-modal--text";
  PartnerProfileEnum2["PARTNER_REDIRECT_MODAL_LINK_REDIRECT"] = "partner-redirect-modal--link-redirect";
  PartnerProfileEnum2["PARTNER_PROFILE_SECTION_SPECIALTIES"] = "partner-profile--specialties";
  PartnerProfileEnum2["PARTNER_PROFILE_SECTION_STRUCTURE"] = "partner-profile--section-structure";
  PartnerProfileEnum2["PARTNER_PROFILE_SECTION_ADDRESS"] = "partner-profile--section-address";
  PartnerProfileEnum2["PARTNER_PROFILE_SECTION_PROFESSIONALS"] = "partner-profile--section-professionals";
  PartnerProfileEnum2["PARTNER_PROFILE_SECTION_RATING"] = "partner-profile--section-rating";
  PartnerProfileEnum2["PARTNER_PROFILE_GALLERY_IMAGE"] = "gallery-image--gallery-component";
  return PartnerProfileEnum2;
})(PartnerProfileEnum || {});
export {
  PartnerProfileEnum
};
